import React from 'react';
import { cropAndResizeImage } from '../../utils/ResizeImage';
import styles from '../agentlistitem/AgentListItem.less';
export var AgentPicture = function AgentPicture(_ref) {
  var pictureUrl = _ref.pictureUrl;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    "data-testid": "agent-picture",
    style: {
      backgroundImage: "url(".concat(cropAndResizeImage(pictureUrl, 160, 160), ")")
    },
    className: "".concat(styles.agentPicture, " agentPicture")
  }));
};